import React, { Component } from "react";
import Layout from "../../layouts/Layout";

import { StyledCircularProgress } from "../../styles/StyledComponents";

import NoData from "../../styles/Illustrations/NoData";
import { EndPoints } from "../../utils/EndPoints";
import moment from "moment";
import CreateDialog from "../../layoutComponents/CreateDialog";
import EditIcon from "@mui/icons-material/Edit";
import { Paper, Tooltip } from "@material-ui/core";
import { stateArray } from "../../Defaults";
import { filterData, getSingleModule_widget } from "../../Regex";
import { accessText } from "../../routes/sidebar";
export class RiceBagSellersComponent extends Component {
  constructor(props) {
    const templateTabs = [
      {
        label: EndPoints["RiceBagSellers"],
        tooltip: `Click to approve pending ${EndPoints["RiceBagSellers"]}`,
        data: [],
        route: `/RiceBagSellers/RiceBagSellers`,
        goBackRoute: "/RiceBagSellers",
        widget: null,
        primaryField: "name",
        primarySecondValue: "total_net_weight",
        primaryFieldFallback: "total_trips", // Optional
        secondaryField: "is_active",
        primaryFieldThirdFallback: "total_net_weight_pending_trips",
        avatarField: "src",

        decorators: {
          conditionField: "status",
          options: ["pending", "approved", "unidentified"],
          colors: ["yellow", "rgb(241 154 48)", "#FF3D00"],
        },
      },
    ];
    super(props);
    this.state = {
      tabs: templateTabs,
      RiceBagSellers: [],
      singlelistView: null,
      loading: false,
      editList: false,
      openDialog: false,
    };
  }
  UNSAFE_componentWillReceiveProps(next) {
    this.setInitialValues(next);
  }
  UNSAFE_componentWillMount() {
    const next = this.props;
    if (next.params && next.params.tab) {
      let tab = next.params.tab;
      if (tab === EndPoints["RiceBagSellers"].split("/")[0] && next.params.id) {
        this.setState(
          {
            singlelistView: this.state.tabs[0].data[next.params.id],
          },
          () => {}
        );
      } else if (tab === "NEW") {
        this.setState({ singlelistView: null });
      }
    } else {
      this.setState({ singlelistView: null });
    }
    this.setInitialValues(this.props);
  }
  listClickHandler = (value) => {
    this.setState({
      singlelistView: value,
    });
  };
  searchHandler = (value) => {
    this.listClickHandler(value);
  };
  setInitialValues(props) {
    const { widget_permission } = getSingleModule_widget(
      props.user,
      accessText.rice_bags,
      accessText.riceBagSellers
    );
    const tabs = this.state.tabs.map((e, i) => {
      const tab = e;
      // has_read_permission:true,has_create_permission:true
      tab.widget = widget_permission?.widget
        ? { ...widget_permission?.widget }
        : null;
    // const tabs = this.state.tabs.map((e, i) => {
      // const tab = e;
      tab.data =
        props[EndPoints["RiceBagSellers"]] &&
        props[EndPoints["RiceBagSellers"]].length > 0
          ? props[EndPoints["RiceBagSellers"]].sort((a, b) => {
              var dateA = moment(b.created_at).format("MMM D YYYY h:mm:ss A");
              var dateB = moment(a.created_at).format("MMM D YYYY h:mm:ss A");
              return new Date(dateA) - new Date(dateB);
            })
          : [];
      return tab;
    });
    this.setState({
      listViewArray:
        props[EndPoints["RiceBagSellers"]] &&
        props[EndPoints["RiceBagSellers"]].length > 0
          ? props[EndPoints["RiceBagSellers"]]
          : [],
      RiceBagSellers: props.RiceBagSellers,
      tabs,
      loading: props.loading,
    });
  }
  fetchList = (res) => {
    if (
      this.state.singlelistView &&
      this.state.singlelistView.id &&
      res &&
      res.id &&
      res.id === this.state.singlelistView.id
    ) {
      this.setState({ singlelistView: res });
    }
    this.props.BrandsManagementsFunction("get", EndPoints["RiceBagSellers"]);
  };
  render() {
    const {
      tabs,
      RiceBagSellers,
      listViewArray,
      singlelistView,
      loading,
      editList,
      openDialog,
    } = this.state;
    const { user } = this.props;

    const { widget_permission } = getSingleModule_widget(
      user,
      accessText.rice_bags,
      accessText.riceBagSellers
    );
    // const { isMobile ,user} = this.props;
    return (
      <Layout
        loading={loading[EndPoints["RiceBagSellers"]]}
        tabs={tabs}
        noTab={true}
        RaisedSearchBar={{
          data: listViewArray && listViewArray.length > 0 ? listViewArray : [],
          hintText: "Search Rice Bag Sellers",
          labelField: "name",
        }}
        listClickHandler={this.listClickHandler}
        serchClick={this.searchHandler}
        centerWidth="230px"
        openWidth="465px"
        closeWidth="287px"
        fabClickHandler={() => {
          this.setState({ openDialog: true, editList: false });
        }}
      >
        <Paper className="width-100 height-100 padding15 backgroundWhite">
          {openDialog === true ? (
            <CreateDialog
              module={"Rice Bag Sellers"}
              closeOnSave={true}
              selectedList={editList ? editList : false}
              editList={editList ? editList : false}
              handleClose={() => {
                this.setState({ openDialog: false });
              }}
              noAddAnother={true}
              fetchAgain={this.fetchList}
              postApi="masters/ricebagseller/list"
              editApi="masters/ricebagseller"
              textFieldStyle={{ width: "calc(50% - 20px)", margin: "10px" }}
              heightNew="500px"
              maxHeight="calc(100vh - 140px)"
              widthNew="700px"
              inputArray={[
                {
                  name: "Active",
                  type: "toggle",
                  defaultValue: {
                    value: editList ? editList.is_active : true,
                  },
                  api: "is_active",
                },
                {
                  name: "Name",
                  type: "textField",
                  dataType: "text",
                  api: "name",
                  defaultValue: {
                    value: editList && editList.name ? editList.name : "",
                  },
                },
                {
                  name: "Phone No",
                  type: "textField",
                  onInput: "phone_number",
                  not_required: true,
                  dataType: "number",
                  api: "phone",
                  defaultValue: {
                    value: editList && editList.phone ? editList.phone : "",
                  },
                },
                {
                  name: "Address",
                  type: "addressTextField",
                  dataType: "text",
                  // not_required: true,
                  api: "address",
                  defaultValue: {
                    value: editList && editList.address ? editList.address : "",
                  },
                },
                {
                  name: "GSTIN",
                  type: "textField",
                  dataType: "text",
                  // not_required: true,
                  onKeyPress: "alphaNum",
                  onInput: "gst_in",
                  api: "gstin",
                  defaultValue: {
                    value: editList && editList.gstin ? editList.gstin : "",
                  },
                },
                {
                  name: "City",
                  type: "textField",
                  // not_required: true,

                  dataType: "text",
                  api: "city",
                  defaultValue: {
                    value: editList && editList.city ? editList.city : "",
                  },
                },
                {
                  name: "State",
                  type: "select",
                  array: stateArray,
                  // not_required: true,
                  value: "name",

                  api: "state",
                  defaultValue: {
                    value: editList && editList.state ? editList.state : "",
                  },
                },
                {
                  name: "Pincode",
                  type: "textField",
                  onInput: "pincode",
                  // not_required: true,

                  dataType: "number",
                  api: "pincode",
                  only_number: true,

                  defaultValue: {
                    value: editList && editList.pincode ? editList.pincode : "",
                  },
                },
              ]}
              postData={this.props.BrandsManagementsFunction}
            />
          ) : (
            ""
          )}
          {singlelistView === null ? (
            <div className="d-flex width-100 height-100 justifyC alignC">
              <NoData />
            </div>
          ) : loading[EndPoints["RiceBagSellers"]] === true ? (
            <div className="alignC justiyC d-flex width-100 height-100">
              <StyledCircularProgress color="inherit" />
            </div>
          ) : (
            <Paper
              className="padding15 backgroundWhite postionR overflowYA scrollBluePrimary"
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
                 {widget_permission?.widget?.has_update_permission && (
              <div className="width-100 d-flex justifyFE">
                <Tooltip title="Edit">
                  <EditIcon
                    onClick={() => {
                      this.setState({
                        openDialog: true,
                        editList: singlelistView,
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
              </div>
                )}
              <div
                className="overflowYA scrollBluePrimary"
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: "0 50px",
                  height: "calc(100% - 31.7px)",
                  // textTransform: "capitalize",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 ",
                      minWidth: "200px",
                    }}
                  >
                    Name:{" "}
                  </p>
                  <p
                    style={{
                      fontSize: "18px",

                      // height: "20vh",
                      // wordWrap: "break-word",
                      margin: "10px 0 10px 10px",
                      color: "#808080",
                      textTransform: "capitalize",
                      wordBreak: "break-all",
                    }}
                  >
                    {singlelistView.name}
                  </p>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    // alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 ",
                      minWidth: "200px",
                    }}
                  >
                    Phone no:
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 10px 10px",
                      color: "#808080",
                    }}
                  >
                    {singlelistView.phone}
                  </p>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    // alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 ",
                      minWidth: "200px",
                    }}
                  >
                    Address:{" "}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 10px 10px",
                      color: "#808080",
                      wordBreak: "break-all",
                    }}
                  >
                    {singlelistView.address}
                  </p>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    // alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 ",
                      minWidth: "200px",
                    }}
                  >
                    GSTIN:{" "}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 10px 10px",
                      color: "#808080",
                    }}
                  >
                    {singlelistView.gstin}
                  </p>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    // alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 ",
                      minWidth: "200px",
                    }}
                  >
                    City:{" "}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 10px 10px",
                      color: "#808080",
                      wordBreak: "break-all",
                    }}
                  >
                    {singlelistView.city}
                  </p>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 ",
                      minWidth: "200px",
                    }}
                  >
                    State:{" "}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 10px 10px",
                      color: "#808080",
                    }}
                  >
                    {singlelistView.state}
                  </p>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    // alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 ",
                      minWidth: "200px",
                    }}
                  >
                    Pincode:{" "}
                  </p>{" "}
                  <p
                    style={{
                      fontSize: "18px",
                      margin: "10px 0 10px 10px",
                      color: "#808080",
                    }}
                  >
                    {singlelistView.pincode}
                  </p>
                </div>
              </div>
            </Paper>
          )}
        </Paper>
      </Layout>
    );
  }
}

export default RiceBagSellersComponent;
